export const UPDATE_MANDATO_UTENTE            = 'UPDATE_MANDATO_UTENTE';
export const UPDATE_COGNOME_UTENTE            = 'UPDATE_COGNOME_UTENTE';
export const UPDATE_NOME_UTENTE 			  = 'UPDATE_NOME_UTENTE';
export const UPDATE_EMAIL_UTENTE 			  = 'UPDATE_EMAIL_UTENTE';
export const UPDATE_CODICE_CONSULENTE_UTENTE  = 'UPDATE_CODICE_CONSULENTE_UTENTE';
export const UPDATE_PROFILO_UTENTE 	   	      = 'UPDATE_PROFILO_UTENTE';
export const UPDATE_DATA_CREAZIONE_UTENTE 	  = 'UPDATE_DATA_CREAZIONE_UTENTE';
export const UPDATE_DATA_SCADENZA_UTENTE  	  = 'UPDATE_DATA_SCADENZA_UTENTE';
export const SALVA_DATI_NUOVA_UTENZA  		  = 'SALVA_DATI_NUOVA_UTENZA';
export const INSERIMENTO_DATI_NUOVA_UTENZA    = 'INSERIMENTO_DATI_NUOVA_UTENZA';